import { race } from 'redux-saga/effects'
import { isArray } from 'utils/types'

// Taken from redux-saga docks/source code, need to update redux-saga to get this
/* eslint-disable no-underscore-dangle, no-return-assign */
export function createMockTask() {
  let _isRunning = true
  let _result
  let _error

  return {
    '@@redux-saga/TASK': true,
    isRunning: () => _isRunning,
    result: () => _result,
    error: () => _error,
    cancel: () => {},

    setRunning: (b) => (_isRunning = b),
    setResult: (r) => (_result = r),
    setError: (e) => (_error = e),
  }
}
/* eslint-enable no-underscore-dangle, no-return-assign */

export function* raceIf(condition, effects) {
  const mockReturn = isArray(effects) ? [] : undefined
  if (!condition) return yield mockReturn

  return yield race(effects)
}
